import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Payments.module.css';
import { buttonClassName } from '../../components/ui/buttonClassName';

/** Uses the loaded readiness reason; never reads a profile to choose an action. */
export function PayeeResolution({
  partnerId,
  reason,
  kycStatus,
  legacy = false,
  canEdit = true,
}: {
  partnerId?: number | null;
  reason?: string | null;
  kycStatus?: string;
  legacy?: boolean;
  canEdit?: boolean;
}) {
  const { t } = useTranslation();
  const location = useLocation();
  if (legacy || !reason || reason === 'NO_FLEET_MANAGER') return null;
  if (!partnerId || !['NO_BANK', 'KYC_PENDING', 'KYC_REJECTED'].includes(reason))
    return (
      <p className={styles.subtle}>{t('payments.payeeResolution.askManager')}</p>
    );
  const bank = reason === 'NO_BANK';
  return (
    <div className={styles.orderActions}>
      <Link
        className={buttonClassName('secondary', 'sm')}
        to={`/users/${partnerId}?tab=kyc${bank ? '#banking-information' : ''}`}
        state={{ from: location.pathname + location.search, fromLabel: 'Return to payments' }}
      >
        {canEdit ? (bank ? 'Add bank details' : 'Review KYC') : 'View partner readiness'}
      </Link>
      {bank && kycStatus && kycStatus !== 'VERIFIED' && (
        <span className={styles.subtle}>{t('payments.payeeResolution.kycAlsoNeedsReview')}</span>
      )}
    </div>
  );
}
